<script setup lang="ts">
import { Form, Head } from "@inertiajs/vue3";

import { Button } from "@/components/ui/button/index";
import SettingsLayout from "@/layouts/settings/layout";
import { settingsPasswordPath } from "@/routes";

defineOptions({ inheritAttrs: false });
</script>

<template>
  <Head title="Password settings" />

  <main
    class="relative flex h-full min-h-0 w-full flex-col gap-3 bg-muted/50 p-3"
  >
    <SettingsLayout
      current="password"
      title="Password settings"
      description="Use a long, unique password for your account."
    >
      <Form
        :action="settingsPasswordPath()"
        method="put"
        :reset-on-success="true"
        #default="{ errors, processing, recentlySuccessful }"
      >
        <div class="space-y-4">
          <div class="space-y-1.5">
            <label for="current-password" class="text-sm font-medium"
              >Current password</label
            >
            <input
              id="current-password"
              name="password_challenge"
              type="password"
              autocomplete="current-password"
              class="input-field"
            />
            <p
              v-if="errors.password_challenge"
              class="text-sm text-destructive"
            >
              {{ errors.password_challenge }}
            </p>
          </div>

          <div class="space-y-1.5">
            <label for="new-password" class="text-sm font-medium"
              >New password</label
            >
            <input
              id="new-password"
              name="password"
              type="password"
              autocomplete="new-password"
              class="input-field"
            />
            <p v-if="errors.password" class="text-sm text-destructive">
              {{ errors.password }}
            </p>
          </div>

          <div class="space-y-1.5">
            <label for="confirm-password" class="text-sm font-medium"
              >Confirm password</label
            >
            <input
              id="confirm-password"
              name="password_confirmation"
              type="password"
              autocomplete="new-password"
              class="input-field"
            />
            <p
              v-if="errors.password_confirmation"
              class="text-sm text-destructive"
            >
              {{ errors.password_confirmation }}
            </p>
          </div>

          <div class="flex items-center gap-3">
            <Button type="submit" :disabled="processing">
              {{ processing ? "Saving..." : "Save password" }}
            </Button>
            <p v-if="recentlySuccessful" class="text-sm text-muted-foreground">
              Saved.
            </p>
          </div>
        </div>
      </Form>
    </SettingsLayout>
  </main>
</template>
